/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import auth from './modules/auth';
import company from './modules/company';
import createAccessProviderModule from '@produtos/store-access-provider';
import createSettingProviderModule from '@produtos/store-setting-provider';
import data from './modules/data';
import databaseLoopbackTransformer from '@i9box/vuelib/src/utils/datatable-loopback-transformer';
import metadata from './modules/metadata';
import transactions from './modules/transactions';
import users from './modules/users';
import vuelib from '@vuelib/store';
/* eslint-enable */

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // padrão vuelib
    vuelib,

    // padrão aplicação
    app,
    auth,

    // provider
    settingProvider: createSettingProviderModule(),
    accessProvider: createAccessProviderModule({
      domainAction: 'settingProvider/$setup',
      pinGetter: 'settingProvider/pin',
      fetchAllAdapter: databaseLoopbackTransformer,
    }),

    users,
    company,
    transactions,
    metadata,
    data,
  },
});
